import React, { useEffect, useState } from "react";
import axios from "axios";
import Style from "../Style/Testimonials.module.scss";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";

const baseURL = process.env.REACT_APP_BASE_URL;

const MAX_HEIGHT_LIMIT = 450; // max height in px

const Testimonials = ({ darkMode }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out-cubic",
      delay: 200,
    });
  }, []);

  const calculateHeights = () => {
    const cardEls = document.querySelectorAll(`.${Style.TestimonialCard}`);
    let tallest = 0;
    cardEls.forEach((el) => {
      tallest = Math.max(tallest, el.offsetHeight);
    });
    tallest = Math.min(tallest, MAX_HEIGHT_LIMIT); // limit max height
    setMaxHeight(tallest);
  };

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${baseURL}/get/testimonials`);
        setTestimonials(res.data);

        // Calculate height after DOM renders
        setTimeout(() => {
          calculateHeights();
          window.addEventListener("resize", calculateHeights);
        }, 200);
      } catch (err) {
        console.error("Failed to fetch testimonials:", err);
      }
    };

    fetchTestimonials();

    return () => {
      window.removeEventListener("resize", calculateHeights);
    };
  }, []);

  return (
    <div
      className={`${Style.TestimonialsSection} ${darkMode ? Style.dark : ""}`}
    >
      <div className={Style.wrapper}>
        <div className={Style.TestimonialDisk} data-aos="zoom-in-up">
          <h2>Testimonials</h2>
          <p>Real Clients-Real Transformations</p>
        </div>
        <div className={Style.TestimonialCards}>
          <Swiper
            modules={[Pagination, Navigation]}
            slidesPerView={2}
            autoHeight={false} // disable autoHeight because we fix height manually
            spaceBetween={30}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            navigation={true}
            loop={true}
            effect="fade"
            fadeEffect={{
              crossFade: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1200}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              769: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className={Style.TestimonialCard}
                  data-aos="zoom-in-up"
                  data-aos-delay={index * 300}
                  style={{
                    height: maxHeight ? `${maxHeight}px` : "auto",
                    overflow: "hidden",
                  }}
                >
                  <div className={Style.Feedback}>
                    <h4>Name : {item.name}</h4>
                    <h3>Location : {item.location}</h3>
                    {item.designation && item.designation !== "N/A" && (
                      <h5>{item.designation}</h5>
                    )}

                    <p>{item.feedback}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className={Style.TestimonialFormDisk} data-aos="zoom-in-up">
          <Link to="/testimonialForm">Share Your Feedback</Link>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
